<ng-container *transloco="let t; prefix: 'login'">
    <div class="container py-5">
        <div class="d-flex justify-content-center">
            <ng-container *ngIf="loginIsError; else loggingIn">
                <button class="btn btn-primary" type="button" *ngIf="loginIsError" (click)="onLoginRetryClick()">
                    {{ t("tryagainbutton") }}
                </button>
            </ng-container>

            <ng-template #loggingIn>
                <div class="overlay-spinner">
                    <div class="visually-hidden">{{ t("loadingtext") }}</div>
                    <loading-spinner-grow />
                </div>
            </ng-template>
        </div>
    </div>

    <div class="modal fade" id="schemaAccessResultDialog" data-bs-backdrop="static" data-bs-keyboard="false"
        tabindex="-1" aria-labelledby="schemaAccessResultDialogLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title" id="schemaAccessResultDialogLabel">
                        <ng-container *ngIf="schemaAccessResult; else schemaAccessFailureTitle">{{ t("schemaaccess.successtitle") }}</ng-container>
                        <ng-template #schemaAccessFailureTitle>{{ t("schemaaccess.failuretitle") }}</ng-template>
                    </h2>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p class="m-0">
                        <ng-container *ngIf="schemaAccessResult; else schemaAccessFailureText">{{ t("schemaaccess.successtext") }}</ng-container>
                        <ng-template #schemaAccessFailureText>{{ t("schemaaccess.failuretext") }}</ng-template>
                    </p>
                </div>
                <div class="modal-footer">
                    <button *ngIf="schemaAccessResult && schemaId" class="btn wp-btn" type="button"
                        data-bs-dismiss="modal" (click)="onOpenSchemaClick()">
                        {{ t("schemaaccess.openschema") }}
                    </button>
                    <button class="btn wp-btn" type="button" data-bs-dismiss="modal">
                        {{ t("schemaaccess.close") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-container>